export default __webpack_public_path__ + "static/media/elevate-bbl-banner-3.e185ee01.jpg";